export default __webpack_public_path__ + "static/media/LabSpecimenNot.4d1547f8.svg";